/**
 * FlahaSOIL v2 — Cation balance chart adapter (Phase 10C-D).
 */
import type { StructureAnalysisBlock } from "@flaha/shared-types";
import type { ScientificChartData, ScientificChartStatus } from "../types/ScientificChartTypes";
import { CHART_UNITS } from "../utils/chartUnits";

export function cationBalanceChartAdapter(
  structure: StructureAnalysisBlock | null
): ScientificChartData<StructureAnalysisBlock | null> {
  const warnings: string[] = [];
  let status: ScientificChartStatus = "READY";

  if (!structure) {
    status = "MISSING_DATA";
  } else if (!structure.matched) {
    status = "PARTIAL_DATA";
    warnings.push("Cation proportions fall outside standard classification polygons.");
  }

  const title = "Cation Balance";
  const description = "Relative proportions of exchangeable Ca, Mg, and K.";
  const source = "Bear/Albrecht (BCSR) Diagnostic";

  let accessibilitySummary = "Cation balance ternary chart.";
  if (structure) {
    accessibilitySummary = `Cation balance is classified as ${structure.classification}. Ca:Mg ratio is ${structure.caMgRatio.toFixed(1)}.`;
  } else {
    accessibilitySummary = "No cation balance data available to plot.";
  }

  return {
    status,
    title,
    description,
    data: structure,
    warnings,
    units: {
      cations: CHART_UNITS.cec,
    },
    source,
    accessibilitySummary,
  };
}
